import { FullDateStr } from 'packages/common-frontend/components/InputsBETA/DateInput';
import { DiffableFormData } from '~/core/routes/settings/implementations/common/types';

export const DAY_COUNT_CONVENTIONS = [
  '30 / 360',
  '30 / 365',
  'Actual / 360',
  'Actual / 365',
  'Actual / Actual',
] as const;
export type DayCountConvention = typeof DAY_COUNT_CONVENTIONS[number];

export type CommitmentProduct = {
  name: string;
  productType: 'loan'; // TODO: support letter of credit
  pricingOptionKey: string;
  /// TODO: margin is a property of the pricing option. Figure out what to do with this.
  // marginType: string;
  // marginValue: string;
  accrualBasis: DayCountConvention;
  maturityMonths: number | null;
};

export type ServicingFeesData = {
  lenderId: string;
  lenderName: string;
  lenderSlug: string;
  servicingFee: number | null;
};

// Some values are strings instead of numbers because that's how
// they arrive from HTML inputs
export type LenderTableData = {
  lenderId: string;
  lenderName: string;
  lenderSlug: string;
  proRataAmount: number | null;
};

export type BaseCommitmentMechanicsFormData = {
  lenders: LenderTableData[];
  products: CommitmentProduct[];
  servicingFees: ServicingFeesData[];
  totalCommitment: number | null;
  maturityDate: FullDateStr | null;
  key: string;
  commitmentName: string;
};

export type CommitmentMechanicsFormData = DiffableFormData<BaseCommitmentMechanicsFormData>;
